import { Component, Output, ViewChild, EventEmitter } from '@angular/core';
import { MultimediumType } from '../../../../common/enums/enums';
import { Localization } from '../../../../common/enums/localization';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ChecklistNode } from '../../checklist/model/checklist-node';
import { VideoSubmittedResponse } from '@npm.chapps.com/chapps.common.angular.library/lib/components/video-recorder/model/video-submitted-response';
import { ImageConverter } from '../../../../common/image-converter';
import { MultimediaViewerService } from '@npm.chapps.com/chapps.common.angular.library';
import { MultimediaService } from '../../../../common/services/multimedia.service';
import { AppConfig } from '../../../../../config/app.config';
import { AppDeleteConfirmModalComponent } from '../../../../common/ui-components/app-delete-confirm-modal/app-delete-confirm-modal.component';
import { noop } from 'underscore';
import { NumberFormatStyle } from '@angular/common';

@Component({
  selector: 'app-edit-node-modal',
  templateUrl: './edit-node-modal.component.html',
  styleUrls: ['./edit-node-modal.component.scss']
})
export class EditNodeModalComponent {

  @Output() confirmed = new EventEmitter<ChecklistNode>();
  @ViewChild('modal') modal: ModalDirective;
  @ViewChild(AppDeleteConfirmModalComponent) deleteConfirmModal: AppDeleteConfirmModalComponent;

  public formGroup: UntypedFormGroup;
  public model: any;
  public readonly Localization = Localization;
  public isMediaAdding: boolean;
  public isCheckpoint: boolean;

  public get labelFormControl(): UntypedFormControl { return this.formGroup.get('label') as UntypedFormControl; }
  public get commentFormControl(): UntypedFormControl { return this.formGroup.get('comment') as UntypedFormControl; }

  constructor(
    public config: AppConfig,
    private multimediaService: MultimediaService,
    private multimediaViewerService: MultimediaViewerService) {
  }


  public show(model: any) {
    this.model = model;
    this.isCheckpoint = this.model.hasOwnProperty('checkPoint');
    if (this.model.multimedia) {
      this.model.multimedia = this.model.multimedia.map(m => {
        if (m.type == MultimediumType.PDF) {
          m.snapshotUrl = this.config.PDF_ICON_URL;
        }
        return m;
      });
    }
    this.initForm();
    this.modal.show();
  }

  public close() {
    this.modal.hide();
  }

  public onClosed() {
    this.formGroup = null;
    this.model = null;
  }

  public initForm() {
    this.formGroup = new UntypedFormGroup({
      'label': new UntypedFormControl(this.model.label, [Validators.required]),
      'comment': new UntypedFormControl(this.model.comment)
    });
  }

  public onSubmit() {
    if (!this.isCheckpoint) {
      if (this.labelFormControl.invalid) {
        this.labelFormControl.markAsTouched();
      }
      else {
        this.model.label = this.labelFormControl.value;
      }
    }
    this.model.comment = this.commentFormControl.value;
    this.confirmed.emit(this.model);
    this.modal.hide();
  }

  public onImageSubmitted(image: File) {
    if (image) {
      this.isMediaAdding = true;
      this.multimediaService.addNewPhotoToNode(this.model.id, image).subscribe(
        photo => {
          this.isMediaAdding = false;
          this.model.multimedia.push(photo);
        },
        () => {
          this.isMediaAdding = false;
        }
      );
    }
  }

  public onDocumentSubmitted(document: File) {
    if (document) {
      this.isMediaAdding = true;
      this.multimediaService.addNewDocumentToNode(this.model.id, document).subscribe(
        document => {
          this.isMediaAdding = false;
          this.model.multimedia.push(document);
        },
        () => {
          this.isMediaAdding = false;
        }
      );
    }
  }

  public onVideoSubmitted(video: VideoSubmittedResponse) {
    this.isMediaAdding = true;
    const snapshotBlob = video.snapshotAsUrl
      ? ImageConverter.dataURItoBlob(video.snapshotAsUrl)
      : null;

    const snapshotFile = snapshotBlob
      ? new File([snapshotBlob], 'snapshot.jpg', { type: 'image/jpeg' })
      : null;

    this.multimediaService.addNewVideoToNode(this.model.id, video.videoFile, snapshotFile).subscribe(
      result => {
        this.isMediaAdding = false;
        this.model.multimedia.push(result);
      },
      () => {
        this.isMediaAdding = false;
      }
    );
  }

  public openDeleteMediaConfirmationPopup(id: number) {
    this.deleteConfirmModal.show(id, Localization.AreYouSureYouWantToDeletePhoto);
  }

  public deleteMedia(id: NumberFormatStyle) {
    this.model.multimedia = this.model.multimedia.filter(photo => photo.id !== id);
    this.multimediaService.deleteMultimediumFromNode(this.model.id, id).subscribe(noop);
  }

  public openMediaInMultimediaViewer(index: number) {
    const multimedium = this.model.multimedia[index];
    if (multimedium.type == MultimediumType.PDF) {
      window.open(multimedium.url, '_blank');
    }
    else {
      this.multimediaViewerService.show(this.model.multimedia, index);
    }
  }

}
